import React from "react";

export default function ClockIcon({ id }) {
    return <svg id={id} width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M26.1833 25.8002L21.0166 22.7168C20.1166 22.1835 19.3833 20.9002 19.3833 19.8502V13.0168" stroke="#FB6503" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M6.66671 10.5009C4.58337 13.2842 3.33337 16.7509 3.33337 20.5009C3.33337 29.7009 10.8 37.1676 20 37.1676C29.2 37.1676 36.6667 29.7009 36.6667 20.5009C36.6667 11.3009 29.2 3.83423 20 3.83423C17.6167 3.83423 15.3334 4.33423 13.2834 5.25089" stroke="#FB6503" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>;
}


// WEBPACK FOOTER //
// ./src/rifa/components/layout/icons/clockIcon.jsx